if (typeof Intl == 'undefined' || !Intl.getCanonicalLocales) {
  require('@formatjs/intl-getcanonicallocales/polyfill')
}

if (!Intl.Locale) {
  require('@formatjs/intl-locale/polyfill')
}

if (!Intl.NumberFormat) {
  require('@formatjs/intl-numberformat/polyfill')
  require('@formatjs/intl-numberformat/locale-data/en')
  require('@formatjs/intl-numberformat/locale-data/de')
  require('@formatjs/intl-numberformat/locale-data/da')
  require('@formatjs/intl-numberformat/locale-data/sv')
  require('@formatjs/intl-numberformat/locale-data/nb')
}

if (!Intl.DateTimeFormat) {
  require('@formatjs/intl-datetimeformat/polyfill')
  require('@formatjs/intl-datetimeformat/locale-data/en')
  require('@formatjs/intl-datetimeformat/locale-data/de')
  require('@formatjs/intl-datetimeformat/locale-data/da')
  require('@formatjs/intl-datetimeformat/locale-data/sv')
  require('@formatjs/intl-datetimeformat/locale-data/nb')
  require('@formatjs/intl-datetimeformat/add-all-tz')
}

if (!Intl.DisplayNames) {
  require('@formatjs/intl-displaynames/polyfill')
  require('@formatjs/intl-displaynames/locale-data/en')
  require('@formatjs/intl-displaynames/locale-data/de')
  require('@formatjs/intl-displaynames/locale-data/da')
  require('@formatjs/intl-displaynames/locale-data/sv')
  require('@formatjs/intl-displaynames/locale-data/nb')
}

if (!Intl.ListFormat) {
  require('@formatjs/intl-listformat/polyfill')
  require('@formatjs/intl-listformat/locale-data/en')
  require('@formatjs/intl-listformat/locale-data/de')
  require('@formatjs/intl-listformat/locale-data/da')
  require('@formatjs/intl-listformat/locale-data/sv')
  require('@formatjs/intl-listformat/locale-data/nb')
}

if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill')
  require('@formatjs/intl-pluralrules/locale-data/en')
  require('@formatjs/intl-pluralrules/locale-data/de')
  require('@formatjs/intl-pluralrules/locale-data/da')
  require('@formatjs/intl-pluralrules/locale-data/sv')
  require('@formatjs/intl-pluralrules/locale-data/nb')
}

if (!Intl.RelativeTimeFormat) {
  require('@formatjs/intl-relativetimeformat/polyfill')
  require('@formatjs/intl-relativetimeformat/locale-data/en')
  require('@formatjs/intl-relativetimeformat/locale-data/de')
  require('@formatjs/intl-relativetimeformat/locale-data/da')
  require('@formatjs/intl-relativetimeformat/locale-data/sv')
  require('@formatjs/intl-relativetimeformat/locale-data/nb')
}

import en from './translations/en.json'
import enGB from './translations/en-GB.json'
import enZA from './translations/en-ZA.json'
import de from './translations/de.json'
import da from './translations/da.json'
import sv from './translations/sv.json'
import nb from './translations/nb.json'
import vtmEn from './translations/en.voicetome.json'
import vtmSv from './translations/sv.voicetome.json'
import vtmNb from './translations/nb.voicetome.json'

const findFirstSupported = (locales) => {
  const supported = Object.keys(supportedLocales)
  return locales.find((code) => supported.includes(code))
}

const stripCountry = (lang) => lang.trim().replace('_', '-').split('-')[0]

const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== defaultLocale ? formatTranslationMessages(defaultLocale, en) : {}
  return Object.keys(messages).reduce((formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== defaultLocale
        ? defaultFormattedMessages[key]
        : messages[key]
    return Object.assign(formattedMessages, { [key]: formattedMessage })
  }, {})
}

const mergeMessages = (originals, overwrites) => {
  return {
    ...originals,
    ...overwrites,
  }
}

const determineLocale = (acceptedLangs, path = null) => {
  if (path !== null) {
    const urlLang = path.trim().split('/')[1]

    const matchingUrlLang = findFirstSupported([urlLang])

    if (matchingUrlLang) {
      return matchingUrlLang
    }
  }

  const matchingAcceptedLang = findFirstSupported(
    acceptedLangs.map(stripCountry)
  )

  return matchingAcceptedLang || defaultLocale
}

const defaultLocale = 'en'

const supportedLocales = {
  en: 'Global',
  'en-gb': 'UK',
  'en-za': 'ZA',
  'de-de': 'DE',
  'da-dk': 'DK',
  // Served only where a brand lists it (src/brands) - VoiceArchive does not.
  'sv-se': 'SE',
  'nb-no': 'NO',
}

const translationMessages = {
  en: formatTranslationMessages('en', en),
  'en-gb': formatTranslationMessages('en-gb', mergeMessages(en, enGB)),
  'en-za': formatTranslationMessages('en-za', mergeMessages(en, enZA)),
  'de-de': formatTranslationMessages('de', de),
  'da-dk': formatTranslationMessages('da', da),
  'sv-se': formatTranslationMessages('sv', sv),
  'nb-no': formatTranslationMessages('nb', nb),
}

// A brand's own copy (the sheet's tab for that brand), used instead of the base table and
// rewritten like it. Empty values fall through to the base table. route.* is always taken
// from the base table: the sitemap, canonicals and the portal's project slugs read it.
const dropEmpty = (messages) =>
  Object.fromEntries(
    Object.entries(messages).filter(
      ([id, text]) => text && !id.startsWith('route.')
    )
  )

const brandMessages = {
  voicetome: {
    en: dropEmpty(vtmEn),
    'sv-se': dropEmpty(vtmSv),
    'nb-no': dropEmpty(vtmNb),
  },
}

export {
  translationMessages,
  brandMessages,
  determineLocale,
  defaultLocale,
  supportedLocales,
}
